import * as React from 'react';
import s from '../../RequestCall.scss';
import { TextButton } from '@wix/design-system';
import { UiProvider } from '../../../../providers/UiProvider';
import { Template } from '../../../../enums';

export interface CancelButtonProps {
  onCancel(): void;
}
export const CancelButton: React.FC<CancelButtonProps> = ({ onCancel }) => (
  <UiProvider>
    {({ t, templateName }) => (
      <div data-hook='cancel-button' className={s.formButtons}>
        <TextButton
          weight='normal'
          skin={templateName === Template.Grid ? 'standard' : 'dark'}
          className={s.cancelButton}
          onClick={onCancel}
        >
          {t(
            'premium_plan.business_enterprise.request_call_form.cancel_button',
          )}
        </TextButton>
      </div>
    )}
  </UiProvider>
);
